<div class="children-section">
    <div class="section-content" [ngClass]="{ 'no-record-selected': noRecordSelected }">
        <div *ngIf="noRecordSelected" class="no-record-message">
            <i class="material-icons">info</i>
            <p>Select a master record to view child relationships</p>
        </div>

        <div *ngIf="!noRecordSelected" class="groups-container">
            <div *ngFor="let group of childGroups; let i = index" class="group-item">
                <div class="group-header" [class.expanded]="group.expanded" (click)="toggleGroup(i)">
                    <i class="material-icons expand-icon" [class.expanded]="group.expanded">expand_more</i>
                    <span class="group-name">{{ group.name }}</span>
                    <span class="group-count">({{ group.data.length }} records)</span>
                </div>
                <div class="group-content" [class.expanded]="group.expanded">
                    <div *ngIf="group.data.length === 0" class="empty-group-message">
                        <i class="material-icons">info_outline</i>
                        <p>This group has no records</p>
                    </div>
                    <ag-grid-angular
                        *ngIf="group.data.length > 0"
                        class="ag-theme-material ag-theme-quartz"
                        style="width: 100%; height: 400px"
                        [columnDefs]="group.gridOptions.columnDefs"
                        [defaultColDef]="group.gridOptions.defaultColDef"
                        [rowData]="group.data"
                        [rowSelection]="group.gridOptions.rowSelection"
                        [rowMultiSelectWithClick]="group.gridOptions.rowMultiSelectWithClick"
                        [suppressNoRowsOverlay]="group.gridOptions.suppressNoRowsOverlay"
                        [pagination]="false"
                        [suppressPaginationPanel]="true"
                        [localeText]="group.gridOptions.localeText"
                        (gridReady)="onGroupGridReady(i, $event)"
                        (rowSelected)="onGroupRowSelected(i, $event)"
                    ></ag-grid-angular>
                </div>
            </div>
        </div>
    </div>

    <div class="section-actions" *ngIf="!noRecordSelected">
        <app-action-row selectedTab="Child" [data]="masterInfo" [activeAdd]="activeAdd" [activeRemove]="activeRemove" [activeChange]="activeChange"></app-action-row>
    </div>
</div>
